import { render, staticRenderFns } from "./PatternUserTableRoles.vue?vue&type=template&id=4fb58d48&scoped=true&"
import script from "./PatternUserTableRoles.vue?vue&type=script&lang=js&"
export * from "./PatternUserTableRoles.vue?vue&type=script&lang=js&"
import style0 from "./PatternUserTableRoles.vue?vue&type=style&index=0&id=4fb58d48&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb58d48",
  null
  
)

export default component.exports